import { FC } from "react";

import { StatusColorType } from "components/materials/page/helpers";
import { PageIcon, PageListIcon, PageListStatusIcon, PageStatusIcon } from "mds/icons";
import { useCapabilities } from "store/capability-hooks";

interface PageItemStatusIconProps {
  color: StatusColorType;
  isMulti?: boolean;
}

export const PageItemStatusIcon: FC<PageItemStatusIconProps> = ({ color, isMulti }) => {
  const { canAuthorCourse } = useCapabilities();

  if (!canAuthorCourse) {
    return isMulti ? <PageListIcon /> : <PageIcon />;
  }

  return isMulti ? (
    <PageListStatusIcon statusColor={color} />
  ) : (
    <PageStatusIcon statusColor={color} />
  );
};
